import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import Paginate from "vuejs-paginate";
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import PageTracker from '../../../common/PageTrackerHelper';
import { applySmartInputStyles, clearSmartInputStyles, createClearInputWatcher } from "../../../common/inputStyleHelper";

export default {
    name: 'MarkingMisrouteODA',
    components: {
        VueElementLoading,
        Treeselect,
        Paginate,
    },
    mixins:[PageTracker],
    data: function() {
        return {
          ShipmentType : '',
          MarkShipmentStatus : '',
          ddlMisrouteReason : [{Reason:"Address pin code mismatch-same city"},{Reason:"Address is closer to other SVC"},{Reason:"Pin code Transferred to new facility"}],
          RtoReason : [{Reason:"Address Pin Code Mismatch: Intercity Pin code"}],
          ddlMisrouteReason1 : '',
          txtShipment : '',
          txtPincode : '',
          ddlHub : '',
          // Rtoerror : '',
          ODAerror : '',
          reasonObj : [],
          shipmentTypeObj : [],
          shipmentStatusObj : [],
          getHubObj : [],
          hubFlag : true,
          DistanceKm : '',
          DistanceFlag : false,
          HubLabelFlag : false,
          hubDiv : true,
          ShipmentType : '',
          hub:'',
          hubid:'',
          currentHubID : '',
          isHubLoading: false,
          isSubmitLoading: false,
          loader:'<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
          ReasonLoader : '',
          HubLoader: '',
          createdBy:'',
          misrouteFlagDel: false,
          misrouteFlagRvp: false,
          misrouteRtoDtoFlag: false,
          ShipmentDetails: null,
          isCorrectPinInput: false,
          isPincodeLoader: false,
          geoPincodeList: [],
          isGeoPincodesAndHub: false,
          geoPincode: '',
          pincodeDerivedFrom: '',
          CurrentAddress: '',
          CurrentPincode: '',
          ReqShipmentType: '',
          misrouteCount: 0,
          isGeoFlowEnabled: false,
          getShipDataLoader: false,
          isPrexo: false,
          requestsSuccMsg: [],
          requestsErrMsg: [],
          dismissCountDown: 0,
          dismissSecs: 20,
          userDataKey : '',
        }
    },
    created: function() {
        this.getShipmentType();
        this.getShipmentStatus();
        this.getHubList();
    },
    watch: {
      txtShipment: createClearInputWatcher('txtShipment'),
    },
    async mounted() {
        this.userDataKey = window.localStorage.getItem('userUniqueKey');
        let validateUser = await this.validateJwtToken();
        var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        //console.log('userdetail',userdetail);
        this.localuserid = userdetail.userid;
        this.localusermailid = userdetail.email;
        this.currentHubID = userdetail.hubdetails[0];
        this.createdBy = userdetail.username;
        let isMisrouteEnabled = await this.getMisrouteEnabledFlag(this.currentHubID);
        this.misrouteFlagDel = isMisrouteEnabled.flagDel;
        this.misrouteFlagRvp = isMisrouteEnabled.flagRvp;
        this.misrouteRtoDtoFlag = isMisrouteEnabled.flagRtoDto;
        this.isGeoFlowEnabled = isMisrouteEnabled.isGeoEnabledForUI;
        if(this.misrouteFlagDel && this.misrouteFlagRvp) {
          this.$alertify.error('Your are not authorized user/hub for Misroute ODA module.!')
          this.$router.push('/MisrouteRequestMaker')
          return false;
        }
        console.log("isMisrouteEnabled",isMisrouteEnabled);
        //console.log('this.currentHubID',this.currentHubID);

    },
    methods: {
      getShipmentType(){
        axios.get(apiUrl.api_url + 'shipmentMisrout/shipmenttype', {})
          .then((response) => {
              if(response.data.code===200){
                  this.shipmentTypeObj=response.data.data;
              }
              else {
                  this.shipmentTypeObj=[];
              }
          })
          .catch((httpException) => {
                this.$alertify.error("Shipment type data not found");
                console.error('exception is:::::::::', httpException)
          })
      },

      gethubagainstAWBandPincode(){
        return new Promise(async (resolve, reject) =>{
          try{
            this.getShipDataLoader = true;
            if(this.txtShipment != '') {
              // if(this.isGeoFlowEnabled === false && this.pincodeDerivedFrom != 'UserPincode'){
              //   await this.misrouteMetaDataLoggingAPI();
              // }

              this.ReasonLoader = this.loader;
              this.isHubLoading = true;
              let pincodeWiseHubRes = await axios.post(apiUrl.api_url + 'shipmentMisrout/pincodeandawbwisehub', {
                "shippingID":this.txtShipment,
                "pincode":this.txtPincode
              })
              if(pincodeWiseHubRes){
                let response = pincodeWiseHubRes;
              // .then(async (response) => {
                if(response.data.code===200){
                  if(response.data.data.shipmentCityInfo.data[0].CityId == response.data.data.hubCityId){
                    if(this.MarkShipmentStatus !== "XBU00260"){
                      this.ODAerror = '(Cannot Mark ODA for Serviceable Pincode.)'
                      this.reasonObj = '';
                      this.ReasonLoader = '';
                    }
                    else{
                      this.reasonObj = this.ddlMisrouteReason;
                      this.ReasonLoader = '';
                      // this.Rtoerror = '';
                      this.ODAerror = '';
                      this.hub=response.data.data.hubName;
                      this.hubid=response.data.data.hubId;
                    }
                  }
                  else if(response.data.data.shipmentCityInfo.data[0].CityId !== response.data.data.hubCityId){
                    if(this.MarkShipmentStatus !== "XBU00260"){
                      this.ODAerror = '(Cannot Mark ODA for Serviceable Pincode.)'
                      this.reasonObj = '';
                      this.ReasonLoader = '';
                    }
                    else{
                      // this.Rtoerror = '(Intercity Pin code Mismatch: RTO Case.)';
                      this.reasonObj = this.RtoReason;
                      this.ReasonLoader = '';
                      this.ODAerror = '';
                      this.hub=response.data.data.hubName;
                      this.hubid=response.data.data.hubId;
                    }
                  }
                  // if(!this.isGeoFlowEnabled){
                  //   this.pincodeDerivedFrom = 'UserPincode';
                  // }
                  // await this.misrouteMetaDataLoggingAPI();
                  this.isHubLoading = false;
                  this.getShipDataLoader = false;
                  return resolve(true);
                }
                else {
                  if(this.MarkShipmentStatus !== "XBU00260"){
                    this.CheckShipmentStatus();
                    // this.ReasonLoader = '';
                    this.ODAerror = '';
                  }
                  else{
                    if(response.data.code==400){
                      this.$alertify.error(response.data.message.details[0].message);
                    }
                    else{
                      this.$alertify.error(response.data.message);
                    }
                    this.isCorrectPinInput = true;
                    this.pincodeDerivedFrom = 'UserPincode';
                    this.txtPincode = '';
                    this.ReasonLoader = '';
                    this.reasonObj = '';
                    // this.Rtoerror = '';
                    this.ODAerror = '';
                    this.hub= '';
                    this.hubid= '';
                    this.isGeoPincodesAndHub = false;
                    this.geoPincode = ''
                  }
                  this.isHubLoading = false;
                  this.getShipDataLoader = false;
                  return resolve(true);
                }
              }
              // })
              // .catch((httpException) => {
              //   this.getShipDataLoader = false;
              //   this.isHubLoading = false;
              //   this.$alertify.error("Please provide valid AWB");
              //   console.error('exception is:::::::::', httpException)
              //   return resolve(true);
              // })
            }else {
              this.getShipDataLoader = false;
              this.isHubLoading = false;
              this.$alertify.error('Please enter shipping id.!');
              return resolve(true);
            }
          }
          catch(e){
            this.getShipDataLoader = false;
            this.isHubLoading = false;
            this.$alertify.error("Please provide valid AWB");
            console.error('exception is:::::::::', e)
            return resolve(true);
          }
        })
      },

      getShipmentStatus(){
        axios.get(apiUrl.api_url + 'shipmentMisrout/shipmentstatus', {})
        .then((response) => {
            if(response.data.code===200){
                this.shipmentStatusObj =response.data.data;
            }
            else {
                this.shipmentStatusObj=[];
            }
        })
        .catch((httpException) => {
            this.$alertify.error("shipmentstatus data not found");
            console.error('exception is:::::::::', httpException)
        })
     },

      getHubList(){
        this.HubLoader = this.loader;
         axios.get(apiUrl.api_url + 'shipmentMisrout/gethublist', {})
          .then((response) => {
              if(response.data.code===200){
                  this.getHubObj =response.data.data;
              }
              else {
                  this.getHubObj=[];
              }
              this.HubLoader = '';
          })
          .catch((httpException) => {
              this.HubLoader = '';
              this.$alertify.error("shipmentstatus data not found");
              console.error('exception is:::::::::', httpException)
          })
      },

      CheckShipmentStatus(){
        this.ReasonLoader = this.loader;
        axios.post(apiUrl.api_url + 'shipmentMisrout/reasondetailsbytype', {
          "ReasonType":this.MarkShipmentStatus
        })
        .then((response) => {
          if(response.data.code === 200){
            if(this.MarkShipmentStatus !== "XBU00260"){
              this.DistanceFlag = true;
              this.hubDiv = false;
              this.ReasonLoader = '';
              this.reasonObj = response.data.data;
              // this.hubFlag = false;
              // this.hubDiv = false;
            }else if(this.MarkShipmentStatus === "XBU00260"){
              this.hubDiv = true;
              this.hubFlag = true;
              this.HubLabelFlag = true;
              this.DistanceFlag = false;
              this.reasonObj = this.ddlMisrouteReason1;
              this.ReasonLoader = '';
            }
            this.ReasonLoader = '';
          }
          else {
              this.reasonObj=[];
              this.ReasonLoader = '';
          }

        })
      .catch((httpException) => {
          this.$alertify.error("Reason Data not found");
          this.ReasonLoader = '';
          console.error('exception is:::::::::', httpException)
      })

      },
      onlyNumber($event){
           let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57 ) && keyCode !== 8 && keyCode !== 44) {
               $event.preventDefault();
            }
      },

      async getReqShipmentData(){
        try{
          this.getShipDataLoader = true;
          this.isCorrectPinInput = false;
          this.isPincodeLoader = this.loader;
          let getShipDataRes = await axios.post(apiUrl.api_url + 'shipmentMisrout/get/shipment/data', {
            "ShippingID":this.txtShipment,
            "LastModifiedBy" : this.localusermailid ,
            "HubID" : this.currentHubID
          })
          if(getShipDataRes){
            let response = getShipDataRes;
            applySmartInputStyles(document.getElementById('txtShipment'), response.data.lossCategorization);
          // .then(async (response) => {
            if(response.data.code === 200 && response.data.data){
              this.ShipmentDetails = response.data.data;
              this.CurrentAddress = this.ShipmentDetails.CustomerAddressDetails.Primary.Address;
              this.CurrentPincode = this.ShipmentDetails.CustomerAddressDetails.Primary.PinCode;
              this.ReqShipmentType = this.ShipmentDetails.LMShipmentType;
              this.misrouteCount = this.ShipmentDetails.ODAMisrouteCount;
              this.isPrexo = this.ShipmentDetails.PrexoID ? true : false;
              if((this.ReqShipmentType.toLowerCase() == 'delivery') && this.misrouteFlagDel){
                this.$alertify.error('Unable to process Delivery shipment as user/hub is not authorized for Delivery Misroute ODA module.!')
                this.$router.push('/MisrouteRequestMaker')
                return false;
              }
              else if((this.ReqShipmentType.toLowerCase() == 'rvp') && this.misrouteFlagRvp){
                this.$alertify.error('Unable to process RVP shipment as user/hub is not authorized for RVP Misroute ODA module.!')
                this.$router.push('/MisrouteRequestMaker')
                return false;
              }

              await this.validateGeoBasedDataForLogging(this.ShipmentDetails,this.isGeoFlowEnabled);
              try {
                let TrackerInfo = {
                  projectname: "Last Mile",
                  type: "Web",
                  userid: this.localuserid,
                  username: this.createdBy,
                  routeurl: "shipmentMisrout/get/shipment/data",
                  meta: {
                    event: "shipmentMisrout-get-shipment/data",
                    shipmentId: this.txtShipment ? this.txtShipment : null,
                    hubId: this.currentHubID ? this.currentHubID : null,
                    remarks: "FrontEnd",
                    LastModifiedBy: this.localusermailid ? this.localusermailid : null,
                  },
                };
                this.PageTracker(TrackerInfo);
              } catch (error) {
                console.log(error);
              }
            }
            else{
              this.$alertify.error(response.data.message);
            }
            this.isPincodeLoader = false;
            this.getShipDataLoader = false;
          // })
          // .catch((httpException) => {
          //   this.isPincodeLoader = false;
          //   this.getShipDataLoader = false;
          //   this.$alertify.error("Shipments data not found");
          //   console.error('exception is:::::::::', httpException)
          // })
          }
        }
        catch(e){
          this.isPincodeLoader = false;
          this.getShipDataLoader = false;
          this.$alertify.error("Shipments data not found");
          console.error('exception is:::::::::', e)
        }
      },

      validateGeoBasedDataForLogging(ShipmentDetails, isGeoEnabledForUI){
        return new Promise(async (resolve, reject) =>{
          if(isGeoEnabledForUI === true){
            let validateRes = await this.validateGeoBasedData(ShipmentDetails);
            return resolve(validateRes);
          }
          else{
            this.isCorrectPinInput = true;
            this.pincodeDerivedFrom = await this.skipGeoBasedDataUIValidation(ShipmentDetails);
            return resolve(true);
          }
        })
      },

      //function uses the UI validation/flow of GEO and also geobased data logging...
      validateGeoBasedData(ShipmentDetails){
        return new Promise(async (resolve, reject) =>{
          this.isGeoPincodesAndHub = (ShipmentDetails.geoCoordinateBased.geohubid && ShipmentDetails.geoCoordinateBased.pincodelist && ShipmentDetails.geoCoordinateBased.pincodelist.length > 0) ? true : false;
          if(this.isGeoPincodesAndHub == true && ShipmentDetails.LMShipmentType.toLowerCase() == 'delivery'){
            this.isCorrectPinInput = false;
            this.HubLabelFlag == true;
            this.hub = ShipmentDetails.geoCoordinateBased.geohubname;
            this.hubid = ShipmentDetails.geoCoordinateBased.geohubid;
            let pincodelist = ShipmentDetails.geoCoordinateBased.pincodelist;
            this.pincodeDerivedFrom = 'GeoCluster';

            for (var i = 0; i < pincodelist.length; i++) {
              if(pincodelist[i].toString().length == 6){
                this.geoPincodeList.push( pincodelist[i]);
              }
            }
            if(ShipmentDetails.CityId == ShipmentDetails.geoCoordinateBased.cityId){
              this.reasonObj = this.ddlMisrouteReason;
              this.ReasonLoader = '';
            }
            else if(ShipmentDetails.CityId != ShipmentDetails.geoCoordinateBased.cityId){
              this.reasonObj = this.RtoReason;
              this.ReasonLoader = '';
            }
            return resolve(true);
          }
          else if(this.isGeoPincodesAndHub == false && ShipmentDetails.geoAPIData.isDestChange == "false" && ShipmentDetails.LMShipmentType.toLowerCase() == 'delivery'){
            this.pincodeDerivedFrom = 'GeoPincode';
            if(ShipmentDetails.geoAPIData.updatedPincode && ShipmentDetails.geoAPIData.updatedPincode.length == 6){
              this.isCorrectPinInput = false;
              this.txtPincode = ShipmentDetails.geoAPIData.updatedPincode.toString();
              await this.gethubagainstAWBandPincode();
            }
            else if((!ShipmentDetails.geoAPIData.updatedPincode || ShipmentDetails.geoAPIData.updatedPincode == '0') && ShipmentDetails.geoAPIData.originalPincode && ShipmentDetails.geoAPIData.originalPincode.length == 6){
              this.isCorrectPinInput = false;
              this.txtPincode = ShipmentDetails.geoAPIData.originalPincode.toString();
              await this.gethubagainstAWBandPincode();
            }
            else{
              this.pincodeDerivedFrom = 'UserPincode';
              this.isCorrectPinInput = true;
              this.txtPincode = '';
            }
            return resolve(true);
          }
          else{
            this.pincodeDerivedFrom = 'UserPincode';
            this.isCorrectPinInput = true;
            this.txtPincode = '';
            return resolve(true);
          }
        })
      },

      //function to skip UI validation/flow of GEO but will do logging as per the GEO...
      skipGeoBasedDataUIValidation(ShipmentDetails){
        return new Promise(async (resolve, reject) =>{
          let pinDerivedFrom = '';
          this.isGeoPincodesAndHub = (ShipmentDetails.geoCoordinateBased.geohubid && ShipmentDetails.geoCoordinateBased.pincodelist && ShipmentDetails.geoCoordinateBased.pincodelist.length > 0) ? true : false;
          if(this.isGeoPincodesAndHub == true && ShipmentDetails.LMShipmentType.toLowerCase() == 'delivery'){
            pinDerivedFrom = 'GeoCluster';
          }
          else if(this.isGeoPincodesAndHub == false && ShipmentDetails.geoAPIData.isDestChange == "false" && ShipmentDetails.LMShipmentType.toLowerCase() == 'delivery'){
            pinDerivedFrom = 'GeoPincode';
          }
          else{
            pinDerivedFrom = 'UserPincode';
          }
          return resolve(pinDerivedFrom);
        })
      },

      //only used for skipGeoBasedDataUIValidation...
      getPincodeWiseHubDetailsForGEO(pincode){
        return new Promise(async (resolve, reject) =>{
          axios.post(apiUrl.api_url + 'shipmentMisrout/pincodeandawbwisehub', {
            "shippingID":this.txtShipment,
            "pincode": pincode
          }).then((response) => {
            if(response.data.code===200){
              let result = {
                "hubName" : response.data.data.hubName,
                "hubId" : response.data.data.hubId,
              }
              resolve(result);
            }
            else{
              resolve(false);
            }
          })
        })
      },

      misrouteMetaDataLoggingAPI(){
        return new Promise(async (resolve, reject) =>{
          try{
            let loggingAPIPayload = {
              "ShippingId": this.txtShipment.trim(),
              "shipmentType": this.ReqShipmentType,
              "logDataObj": {
                "currentHubId": this.currentHubID,
                "currentPincode": this.CurrentPincode,
                "currentAddress": this.CurrentAddress,
                "misroutecount": this.misrouteCount ? this.misrouteCount : 0,
              },
              "misrouteMetadataSource": this.pincodeDerivedFrom,
              "userId": this.localuserid,
              "LastModifiedBy": this.localusermailid,
              "requestedFrom": "OldModule",
              // "isShadowModeOff": this.isGeoFlowEnabled
            }
            if(this.isGeoFlowEnabled === true){
              loggingAPIPayload.logDataObj.suggestedHubId = this.hubid;
              loggingAPIPayload.logDataObj.suggestedHub = this.hub;
              loggingAPIPayload.logDataObj.suggestedPincode = (this.txtPincode=='')?null:this.txtPincode;
              if(this.isGeoPincodesAndHub == true && this.geoPincode){
                loggingAPIPayload.logDataObj.suggestedPincode = this.geoPincode;
              }
            }
            else{
              if(this.isGeoPincodesAndHub == true && (!this.hubid || !this.hub)){
                loggingAPIPayload.logDataObj.suggestedHubId = this.ShipmentDetails.geoCoordinateBased.geohubid;
                loggingAPIPayload.logDataObj.suggestedHub = this.ShipmentDetails.geoCoordinateBased.geohubname;
                loggingAPIPayload.logDataObj.suggestedPincode = this.ShipmentDetails.geoCoordinateBased.pincodelist[0];
                loggingAPIPayload.isShadowModeOff = this.isGeoFlowEnabled;
              }
              else if(this.isGeoPincodesAndHub == false && this.ShipmentDetails.geoAPIData.isDestChange == "false" && (!this.hubid || !this.hub)){
                if(this.ShipmentDetails.geoAPIData.updatedPincode && this.ShipmentDetails.geoAPIData.updatedPincode.length == 6){
                  let hubDetails = await this.getPincodeWiseHubDetailsForGEO(this.ShipmentDetails.geoAPIData.updatedPincode);
                  loggingAPIPayload.logDataObj.suggestedHubId = hubDetails.hubId ? hubDetails.hubId : null;
                  loggingAPIPayload.logDataObj.suggestedHub = hubDetails.hubName ? hubDetails.hubName : null;
                  loggingAPIPayload.logDataObj.suggestedPincode = this.ShipmentDetails.geoAPIData.updatedPincode;
                }
                else if((!this.ShipmentDetails.geoAPIData.updatedPincode || this.ShipmentDetails.geoAPIData.updatedPincode == '0') && this.ShipmentDetails.geoAPIData.originalPincode && this.ShipmentDetails.geoAPIData.originalPincode.length == 6){
                  let hubDetails = await this.getPincodeWiseHubDetailsForGEO(this.ShipmentDetails.geoAPIData.originalPincode);
                  loggingAPIPayload.logDataObj.suggestedHubId = hubDetails.hubId ? hubDetails.hubId : null;
                  loggingAPIPayload.logDataObj.suggestedHub = hubDetails.hubName ? hubDetails.hubName : null;
                  loggingAPIPayload.logDataObj.suggestedPincode = this.ShipmentDetails.geoAPIData.originalPincode;
                }
                else{
                  loggingAPIPayload.logDataObj.suggestedHubId = this.hubid;
                  loggingAPIPayload.logDataObj.suggestedHub = this.hub;
                  loggingAPIPayload.logDataObj.suggestedPincode = this.txtPincode;
                }
                loggingAPIPayload.isShadowModeOff = this.isGeoFlowEnabled;
              }
              else{
                loggingAPIPayload.logDataObj.suggestedHubId = this.hubid;
                loggingAPIPayload.logDataObj.suggestedHub = this.hub;
                loggingAPIPayload.logDataObj.suggestedPincode = this.txtPincode;
                loggingAPIPayload.isShadowModeOff = true;
              }
            }

            let logApiRes = await axios.post(apiUrl.api_url + 'misroute/general/metadatasource/logging', loggingAPIPayload)
            if(logApiRes){
              let response = logApiRes;
            // .then((response) => {
              if(response.data.code != 200 && this.ReqShipmentType.toLowerCase() == 'delivery'){
                this.$alertify.warning("Logging the details");
                resolve(true);
              }
              resolve(true);
            }
            // })
            // .catch((e) => {
            //   console.log('error in misrouteMetaDataLoggingAPI :', e);
            //   resolve(false);
            // });
          }
          catch(e){
            console.log('error in misrouteMetaDataLoggingAPI :', e);
            resolve(false);
          }
        })
      },

      validateForm(scope) {
        this.$validator.validateAll(scope).then(result => {
          if (result) {
            this.isSubmitLoading = true;
              // if(this.Rtoerror!=''){
              //   let message = {
              //     title: '',
              //     body: `<p>The Shipment will be marked as RTO.</p> <p>Do you want to proceed?</p>`,
              //   };
              //   this.$dialog.confirm(message, {
              //     html: true,
              //     animation: 'bounce',
              //     backdropClose: true,
              //     okText: 'Yes',
              //     cancelText: 'No',
              //     reverse: true,
              //     loader: true
              //   })
              //   .then(dialog=>{
              //     this.isSubmitLoading = true;
              //     let Payload = {
              //       "ShippingID" : this.txtShipment.trim(),
              //       "CancellationReason" : this.ddlMisrouteReason1.toString(),
              //       "IsMSSQL" : "true",
              //       "RequestType" : "web",
              //       "LastModifiedBy" : this.localusermailid
              //     }
              //     axios.post(apiUrl.api_url + 'shipmentMisrout/markshipment/rto',Payload)
              //     .then(result => {
              //       if(result.data.code == 200) {
              //         this.$alertify.success("Shipment Marked As RTO Successfully.")
              //         // this.clear();
              //       } else {
              //         this.$alertify.error(result.data.data.ReturnMessage);
              //         // this.clear();
              //       }
              //       dialog.close();
              //       this.clear();
              //       this.isSubmitLoading = false;
              //     })
              //   })
              // }
              // else{
              //console.log('form submited');
              var markingMisRoutePayload = {
                shipmenttype : this.ShipmentType.toString(),
                markShipmentStatus : this.MarkShipmentStatus,
                reason : this.ddlMisrouteReason1.toString(),
                shippingid :  this.txtShipment.trim(),
                hubid:this.hubid,
                distance : this.DistanceKm,
                LastModifiedBy : this.localusermailid,
                currentHubID: this.currentHubID,
                misrouteMetadataSource: this.pincodeDerivedFrom ? this.pincodeDerivedFrom : null
              }
              if(this.isGeoPincodesAndHub == true && this.geoPincode){
                markingMisRoutePayload.pincode = this.geoPincode
              }
              else{
                markingMisRoutePayload.pincode = (this.txtPincode=='')?null:this.txtPincode
              }

              this.isSubmitLoading = true;
              //console.log(markingMisRoutePayload);
              axios.post(apiUrl.api_url + 'shipmentMisrout/markshipmentasmisroute', markingMisRoutePayload)
              .then((response) => {
                if(response.data.code == 200){
                  //tracker api called here
                let TrackerInfo = {
                  projectname:"Last Mile",
                  type:"Web",
                  userid:this.localuserid,
                  username:this.localusermailid,
                  meta: {
                      "event":"MarkingMisrouteODA",
                      "shipment": this.txtShipment.trim().toString(),
                      "markShipmentStatus" : this.MarkShipmentStatus,
                      "reason" : this.ddlMisrouteReason1.toString(),
                  }
              }
              this.PageTracker(TrackerInfo)
              //end
                  if(this.isPrexo){
                    this.dismissCountDown = this.dismissSecs;
                    this.requestsSuccMsg = response.data.data;
                  }
                  else{
                    this.$alertify.success(response.data.message);
                  }
                  this.txtShipment = '';
                  this.txtPincode = '';
                  this.DistanceKm = '';
                  this.$validator.reset();
                  this.errors.clear();
                }
                else {
                  if(this.isPrexo && response.data.data && response.data.data.length > 0){
                    this.dismissCountDown = this.dismissSecs;
                    this.requestsErrMsg = response.data.data;
                  }
                  else if(!this.isPrexo && response.data.data && response.data.data.length > 0){
                    this.$alertify.error(response.data.data[0].message);
                  }
                  else{
                    this.$alertify.error(response.data.message);
                  }
                }
                this.isSubmitLoading = false;
                this.clear();
              })
              .catch((httpException) => {
                this.isSubmitLoading = false;
                this.$alertify.error("Unable to Update Record");
                this.clear();
                console.error('exception is:::::::::',httpException)
              });
            // }
          }
        }).catch(() => {
          this.isSubmitLoading = false;
          console.log('errors exist', this.errors)
        });
      },

      CloseSuccessErrorRes(){
        this.requestsSuccMsg = [];
        this.requestsErrMsg = []
      },
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown;
      },

      clear(){
        this.ShipmentType = '',
        this.MarkShipmentStatus = '',
        this.ddlMisrouteReason1 = '',
        // this.Rtoerror = '',
        this.ODAerror = '',
        this.txtShipment = '',
        this.txtPincode = '',
        this.ddlHub = '',
        this.reasonObj = [],
        this.hub= '';
        this.hubid= '';
        this.hubFlag = true,
        this.DistanceKm = '',
        this.DistanceFlag = false,
        this.HubLabelFlag = false,
        this.hubDiv = true,
        this.isCorrectPinInput = false;
        this.isGeoPincodesAndHub = false;
        this.geoPincodeList = [],
        this.geoPincode = '',
        this.pincodeDerivedFrom = '',
        this.CurrentAddress = '',
        this.CurrentPincode = '',
        this.misrouteCount = 0,
        this.ReqShipmentType = '',
        this.isPrexo = false;
        clearSmartInputStyles(document.getElementById('txtShipment'));
        this.$validator.reset();
        this.errors.clear();
    },
  }
}

//extended validation
Validator.extend('IsValidNo', {
  getMessage: field => { return 'Please Enter only number.!'},
  validate: value => {
    let numberRegex = /^[0-9]+$/;
    if(numberRegex.test(value) == true){
      return true;
    } else {
      return false;
    }
  }
})

Validator.extend('IsValidDist', {
  getMessage: field => {return 'Distance cannot be more than 999 KM.!'},
  validate: value => {
    if( value <= 999 ){
      return true;
    } else {
      return false;
    }
  }
})



// WEBPACK FOOTER //
// ./src/views/components/MarkingMisrouteODA/MarkingMisrouteODA.component.js